import Loader from '@/components/ui/Loader'
import EmptyDatas from 'components/ui/EmptyDatas'
import React from 'react'
import useSWR from 'swr'
import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import DropdownOrder from './DropdownOrder'
import Item from './Item'
import { Card, CardContent } from '@/components/ui/card'

import MyPagination from 'components/ui/MyPagination'
import MyRefetchButton from 'components/ui/MyRefetchButton'
import Create from './Create'

const PAGE_SIZE = 90

export const useForm = create(
  persist(
    (set) => ({
      order: 'updateTime',
      after: null,
      afters: [],
      setOrder: (order) => set({ order, after: null, afters: [] }),
      goAfter: (nextAfter) =>
        set((state) => {
          if (nextAfter === null) {
            return { after: null }
          }
          const index = state.afters.findIndex((a) => a === nextAfter)
          if (index === -1) {
            return {
              after: nextAfter,
              afters: [...state.afters, nextAfter],
            }
          } else {
            return { after: nextAfter }
          }
        }),
    }),
    {
      name: 'webimgs-form',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)

const WebImgs = () => {
  const goAfter = useForm((state) => state.goAfter)
  const afters = useForm((state) => state.afters)
  const after = useForm((state) => state.after)

  const params = useForm((state) => {
    const order = state.order
    const after = state.after
    return after ? { order, after, limit: PAGE_SIZE } : { order, limit: PAGE_SIZE }
  })
  const { data, isLoading, isValidating, mutate } = useSWR(['/webimgs', params])

  const nextAfter =
    data?.length >= PAGE_SIZE ? data[data.length - 1]?.id : undefined
  const isLoadingData = isLoading || isValidating

  return (
    <div className="flex h-[calc(100vh-98px)] flex-col space-y-4">
      <div className="flex-shrink-0">
        <h2 className="text-3xl font-bold tracking-tight">WebImages</h2>
      </div>

      <div className="flex w-full flex-shrink-0 flex-wrap items-center justify-between gap-x-4 gap-y-2">
        <div className="flex min-w-0 flex-wrap items-center gap-x-4 gap-y-2">
          <div className="flex shrink-0 items-center gap-4">
            <MyPagination
              nextAfter={nextAfter}
              after={after}
              goAfter={goAfter}
              afters={afters}
              className="m-0 w-auto"
            />
            <MyRefetchButton onClick={() => mutate()} />
          </div>
          <div className="flex items-center gap-2">
            <label
              htmlFor="webimgs-order"
              className="shrink-0 text-sm font-medium"
            >
              Order:
            </label>
            <DropdownOrder />
          </div>
        </div>
        <div className="shrink-0">
          <Create mutateCurrList={mutate} />
        </div>
      </div>

      {isLoadingData && <Loader />}
      {!isLoadingData && data?.length <= 0 && <EmptyDatas />}
      {!isLoadingData && data?.length > 0 && (
        <div className="min-h-0 flex-1">
          <Card className="flex h-full flex-col">
            <CardContent className="min-h-0 flex-1 overflow-hidden pb-0 pl-6 pr-0">
              <div className="h-full overflow-auto">
                <div className="my-6 mr-6 grid grid-cols-9 gap-2 lg:grid-cols-6 xl:grid-cols-9">
                  {data.map((item) => (
                    <Item key={item.id} data={item} />
                  ))}
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      )}
    </div>
  )
}

export default WebImgs
